import { render, staticRenderFns } from "./LineChartLegend.vue?vue&type=template&id=183dd98a&"
import script from "./LineChartLegend.vue?vue&type=script&lang=js&"
export * from "./LineChartLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports